export default __webpack_public_path__ + "static/media/011-archery.7017fbcc.svg";